module.exports = __webpack_public_path__ + "img/md5-normal5.ddee2f72.png";